import { default as AxoFinansLogo } from '@axo/ui-core/@assets/brand/axo-finans-logo.svg';
import { default as CentumLogo } from '@axo/ui-core/@assets/brand/centum-logo.svg';
import { default as LendMeLogo } from '@axo/ui-core/@assets/brand/lendme-axo-logo.svg';
import { default as uLoanLogo } from '@axo/ui-core/@assets/brand/uloan-axo-logo.svg';
import { default as ZmartaLogo } from '@axo/ui-core/@assets/brand/zmarta-logo.svg';
import { default as FreedomFinanceLogo } from '@axo/ui-core/@assets/brand/freedom-finance-logo.svg';
import { default as AxolainaLogo } from '@axo/ui-core/@assets/brand/axo-laina-logo.svg';
import { default as LendMeAxoLogo } from '@axo/ui-core/@assets/brand/lendme-axo-logo.svg';
import { default as FreedomRahoitusLogo } from '@axo/ui-core/@assets/brand/freedom-rahoitus-logo.svg';
import { default as UScoreLogo } from '@axo/ui-core/@assets/brand/uscore-logo.svg';
import { Brand } from '@axo/config/@types/Brand.types';

export const BRAND_LOGO_MAPPING: Record<Brand, string> = {
  'axofinans.no': AxoFinansLogo,
  'centum.no': CentumLogo,
  'lendme.no': LendMeAxoLogo,
  'uloan.no': uLoanLogo,
  'zmarta.no': ZmartaLogo,
  'axofinans.se': AxoFinansLogo,
  'freedomfinance.se': FreedomFinanceLogo,
  'zmarta.se': ZmartaLogo,
  'lendme.dk': LendMeLogo,
  'zmarta.fi': ZmartaLogo,
  'axolaina.fi': AxolainaLogo,
  'freedomrahoitus.fi': FreedomRahoitusLogo,
  'uscore.fi': UScoreLogo,
  'uscore.no': UScoreLogo,
  'uscore.se': UScoreLogo,
};
